class Monitoring.Methods.RenderWordCloud extends Backbone.View

  initialize:(data, options={}) =>
    @options = options
    @data = @filterData(data)

  renderInElement: (domElements) =>
    if _.isEmpty(@data)
      console.warn("Tried to render a word cloud with no data")
    else
      console.log("Rendering cloud with " + @data.length + " elements")

    defaultOptions = {
      textField: 'topic'
    }

    options = $.extend({}, defaultOptions, @options)
    @maxSize = options["max_size"] || 43
    @minSize = options["min_size"] || 12
    cloudElements = @cloudElements(@data, options)
    WordCloud(domElements, @optionsForCloudComponent(cloudElements, options))
    cloudElements # this return value is used when exporting the campaign report

  # private

  optionsForCloudComponent: (cloudElements, options) =>
    defaultOptions = {
      list: cloudElements
      weightFactor: 0.7
      rotateRatio: 0
      shape: 'circle'
      fontFamily: 'Roboto'
      gridSize: 18
      color: WordCloud.randomColor
    }
    $.extend({}, defaultOptions, options)

  cloudElements: (data, options) =>
    [maxScore, minScore] = @maxAndMinScores(data)
    _.map(data, (e) => @cloudElement(e, options, maxScore, minScore, data.length) )

  maxAndMinScores: (data) ->
    [max, min] = [null, null]

    _.each(data, (e) ->
      max = e.score if (max == null || e.score > max)
      min = e.score if (min == null || e.score < min)
    )

    min = max - 1 if max == min
    [max, min]

  cloudElement: (e, options, maxScore, minScore, wordCount) =>
    text = @formattedText(e[options.textField], options)
    size = @size(e.score, maxScore, minScore, wordCount)
    [text, size]

  formattedText: (text, options) =>
    max_length = 25
    if options["text_max_length"]
      max_length = options["text_max_length"]
    # if !options["full_domains"]
    #   text = @extractUrlDomain(text)
    @withEllipsis(max_length, text)

  withEllipsis: (max_length, text) ->
    if text.length > max_length then text.substring(0, max_length - 3) + "..." else text

  size: (value, maxScore, minScore, wordCount) ->
    delta = maxScore - minScore
    percentage = (value - minScore) * 100 / delta
    @sizeFromPercentage(percentage, wordCount)

  sizeFromPercentage: (percentage, wordCount) =>
    if wordCount < 6
      minSize = (@maxSize+@minSize)/2
    else
      minSize = @minSize
    scaleFactor =  @maxSize - minSize
    (percentage * scaleFactor / 100) + minSize

  # this logic was used up until v1.16
  sizeOld: (score, max, min = 1) ->
    d3.scale.log().domain([min, max]).range([8, 40])(score)

  # extractUrlDomain: (url) =>
  #   if @isUrl(url)
  #     domain = url.split('/')[2]
  #   else
  #     return url
  #   domain.split(':')[0]

  filterData: (data) =>
    if @options["filter_urls"]
      return data.filter (x) => not @isUrl(x.topic)
    else
      return data

  isUrl: (url) =>
    url.indexOf('://') > -1

  data: =>
    @data
